import { empty } from './_consts';
/**
 * Returns all characters in the string as an array.
 * @param str
 */
export default function toCharArray(str) {
    return str.split(empty);
}
